import * as React from 'react';

import './ResultRow.css';

import { IHit } from '../api';
import TimeFormat from '../lib/TimeFormat';

function formatResult(result: IHit): JSX.Element[] {
    let { highlight } = result;
  
    const regex = /(<\/?em>)/g;
    if (highlight.match(regex)) {
      highlight = highlight.replace(regex, ' $1 ');
    }
  
    let tokens = highlight.split(' ');
  
    if (tokens[0] === '') {
      tokens = tokens.slice(1);
    }
    if (tokens[tokens.length] === '') {
      tokens = tokens.slice(0, -1);
    }
  
    let isHighlight = false;
    const spans = [];
    for (let i = 0; i < tokens.length; i++) {
      const token = tokens[i];
  
      if (token === '<em>') {
        isHighlight = true;
      } else if (token === '</em>') {
        isHighlight = false;
      } else {
        let className = 'token';
        if (isHighlight) {
          className += ' highlight';
        }
        spans.push(<span key={i}><span className={className}>{token}</span> </span>);
      }
    }
  
    return spans;
  }

  interface IProps {
    playing: boolean,
    onSelect: (hit: IHit) => void,
    onPreview: (hit: IHit) => void,
    result: IHit,
  }
  
  export class ResultRow extends React.Component<IProps> {
      public render() {
        const {
            playing,
            result,
        } = this.props;

        return (
            <div
              onClick={ this.onPreview }
              onMouseOver={this.onMouseOver}
              className={"result" + (playing ? ' playing' : '') }>
                <span className="segid">{ TimeFormat.toHHMMSS(result.start) }</span>
                <span className="snippet">{ formatResult(result) }</span>
            </div>
        );
    }

    private onPreview = () => {
        this.props.onPreview(this.props.result);
    }

    private onMouseOver = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.shiftKey) {
            this.props.onPreview(this.props.result);
        }
    }

}

  export default ResultRow;



// WEBPACK FOOTER //
// ./src/components/ResultRow.tsx